var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { cn, formatPhoneNumber } from '../../lib/utils.js';
import { UserAvatar } from './user-avatar';
import { CopyToClipboardButton } from '../ui-custom/copy-to-clipboard-button';
/**
 * A component that displays a user's avatar alongside their name
 */
export function UserAvatarWithName(_a) {
    var avatarClassName = _a.avatarClassName, className = _a.className, _b = _a.copyableEmail, copyableEmail = _b === void 0 ? false : _b, email = _a.email, emailClassName = _a.emailClassName, firstName = _a.firstName, lastName = _a.lastName, phone = _a.phone, phoneClassName = _a.phoneClassName, nameClassName = _a.nameClassName, _c = _a.showEmail, showEmail = _c === void 0 ? false : _c, _d = _a.showPhone, showPhone = _d === void 0 ? false : _d, userIconFallbackClassName = _a.userIconFallbackClassName, props = __rest(_a, ["avatarClassName", "className", "copyableEmail", "email", "emailClassName", "firstName", "lastName", "phone", "phoneClassName", "nameClassName", "showEmail", "showPhone", "userIconFallbackClassName"]);
    var fullName = React.useMemo(function () {
        return [firstName, lastName].filter(Boolean).join(' ') || 'Unknown User';
    }, [firstName, lastName]);
    return (<div className={cn('flex items-center gap-2', className)}>
      <UserAvatar firstName={firstName} lastName={lastName} className={avatarClassName} userIconFallbackClassName={userIconFallbackClassName} {...props}/>
      <div className={cn(copyableEmail && 'min-w-0')}>
        <div className={cn('truncate', nameClassName)}>{fullName}</div>
        {showEmail && email && (<div className={cn('text-muted-foreground text-xs', copyableEmail && 'flex items-center gap-1', emailClassName)}>
            {copyableEmail ? <span className="min-w-0 truncate">{email}</span> : email}
            {copyableEmail && (<CopyToClipboardButton 
            // Negative margin keeps the button from growing the row height
            className="-my-1" stringToCopy={email} tooltipText="Copy email"/>)}
          </div>)}
        {showPhone && formatPhoneNumber(phone) && (<div className={cn('text-muted-foreground text-xs', phoneClassName)}>
            {formatPhoneNumber(phone)}
          </div>)}
      </div>
    </div>);
}
